export const messages = {
  title: {
    id: 'admin/promotions.form.buy-and-win.benefit.title',
  },
  emptyTitle: {
    id: 'admin/promotions.form.buy-and-win.benefit.empty.description',
  },
  addBenefit: {
    id: 'admin/promotions.form.buy-and-win.benefit.empty.add-benefit',
  },
  menu: {
    id: 'admin/promotions.form.buy-and-win.benefit.empty.benefit-options.menu-aria',
  },
  drawer: {
    apply: {
      id: 'admin/promotions.utils.apply',
    },
    cancel: {
      id: 'admin/promotions.utils.cancel',
    },
  },
  freeShipping: {
    label: {
      id: 'admin/promotions.form.buy-and-win.benefit.free-shipping.label',
    },
    description: {
      id: 'admin/promotions.form.buy-and-win.benefit.free-shipping.description',
    },
    free: {
      id: 'admin/promotions.form.buy-and-win.benefit.free-shipping.content.free',
    },
  },
  gift: {
    label: { id: 'admin/promotions.form.buy-and-win.benefit.gift.label' },
    description: {
      id: 'admin/promotions.form.buy-and-win.benefit.gift.description',
    },
    detail: {
      active: {
        id: 'admin/promotions.form.benefit.gift.description.per-item',
      },
      inactive: {
        id: 'admin/promotions.form.benefit.gift.description.per-cart',
      },
    },
  },
  maxUnitPrice: {
    label: {
      id: 'admin/promotions.form.buy-and-win.benefit.max-unit-price.label',
    },
    description: {
      id: 'admin/promotions.form.buy-and-win.benefit.max-unit-price.description',
    },
  },
  apply: {
    id: 'admin/promotions.utils.apply',
  },
  cancel: { id: 'admin/promotions.utils.cancel' },
}

export default messages
